// NOTE: this method is duplicated from `@gig/magic-account/dist/util`
/**
 * Checks whether given text contains a number
 * @param value Text to check
 */
function containsNumber(value) {
    return /\d/.test(value);
}

export { containsNumber };
